// This file should only contain action type constants.

export const SET_WIS_FACETS = 'SET_WIS_FACETS';
export const SET_WIS_INVENTORY = 'SET_WIS_INVENTORY';
export const SET_MORE_REQUEST_DATA = 'SET_MORE_REQUEST_DATA';
